const TIMEOUT = 1000 * 40

function shoppingAssistantApiFactory(storefrontApiClient) {
  return {
    sendMessage(params) {

      return storefrontApiClient.post(
        '/shopping-assistant/send-message',
        params,
        {
          timeout: TIMEOUT,
          withCredentials: true
        }
      );
    },
    deleteChat() {
      return storefrontApiClient.get(
        '/shopping-assistant/delete-chat-history',
        {
          timeout: TIMEOUT,
          withCredentials: true
        }, {}, {
          cacheStatus: false,
        }
      );
    },
    getContract() {
      return storefrontApiClient.get('/shopping-assistant/get-contract', {
        timeout: TIMEOUT,
        withCredentials: true
      }, {}, {
        cacheStatus: false
      });
    },
    approveContract({version} = {}) {
      return storefrontApiClient.get(
        `/shopping-assistant/approve-contract/${version}`,
        {
          timeout: TIMEOUT,
          withCredentials: true
        }, {}, {
          cacheStatus: false,
        }
      );
    },
  };
}

export default shoppingAssistantApiFactory;
